<script scoped>
import axios from "axios";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      formData: {
        pb_kode: "",
        pb_name: "",
        pb_id: null,
      },
      dahanProfesiOption: [],
    };
  },
  props: ["typeTrans", "dataProfesi"],
  watch: {
    dataProfesi: function (newVal) {
      if (newVal == null) {
        this.formData = {
          pb_kode: "",
          pb_name: "",
          pb_id: null,
        };
      } else {
        this.formData = {
          pb_kode: newVal.pb_kode,
          pb_name: newVal.pb_name,
          pb_id: newVal.pb_id,
        };
      }
    },
  },
  emits: ["submitForm"],
  methods: {
    async submitForm() {
      if (!this.validateForm()) {
        return;
      }

      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: "Loading...",
        showConfirmButton: false,
        allowOutsideClick: false,
      });

      let payload = { ...this.formData };
      const url =
        this.typeTrans == "add"
          ? "master/pohon-bisnis"
          : `master/pohon-bisnis/${this.formData.pb_id}`;
      const method = this.typeTrans == "add" ? "post" : "put";
      const config = {
        method: method,
        url: process.env.VUE_APP_BACKEND_URL_VERSION + url,
        data: payload,
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
          "Content-type": "application/json",
        },
      };
      await axios(config)
        .then((response) => {
          console.log({ response });
          Swal.fire({
            icon: "success",
            title: "Berhasil",
            text: "",
            timer: 2000,
            timerProgressBar: true,
            showCancelButton: false,
            showConfirmButton: false,
          }).then((result) => {
            console.log({ result });
            Swal.close();
            this.$emit("submitForm");
          });
        })
        .catch((error) => {
          console.log({ error });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error.response.data.data,
          });
        });
    },
    validateForm() {
      if (this.formData.pb_kode === "" || this.formData.pb_name === "") {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Silahkan Lengkapi Data",
        });

        return false;
      }

      return true; // Form is valid
    },
  },
  mounted() {
  },
};
</script>

<template>
  <div class="container">
    <form @submit.prevent="submitForm" class="needs-validation" novalidate>
      <div class="form-group mb-3">
        <label for="kodeProfesi" class="form-label">Kode Pohon Bisnis</label>
        <input
          type="text"
          v-model="formData.pb_kode"
          class="form-control"
          id="kodeProfesi"
          placeholder="Kode Bisnis..."
        />
      </div>
      <div class="form-group mb-3">
        <label for="namaProfesi" class="form-label">Nama Pohon Bisnis</label>
        <input
          type="text"
          v-model="formData.pb_name"
          class="form-control"
          id="namaProfesi"
          placeholder="Nama Bisnis..."
        />
      </div>
      <div class="form-group float-end">
        <button class="btn btn-primary">
          <i class="fa fa-save"></i> Simpan
        </button>
      </div>
    </form>
  </div>
</template>
